import Home from './pages/Home';

function App() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <main className="py-12">
        <Home />
      </main>
    </div>
  );
}

export default App; 